import { Dictionary } from '@/types/field'
import { createSelector } from 'reselect'

// Select entities from state
const getProfileState = (state: Dictionary) => state.profile

// = ====================================
//  MEMOIZED SELECTORS
// -------------------------------------

export const getProfileInfo = createSelector(getProfileState, (data: Dictionary) => {
    return {
        user: data.user ?? {}
    }
})
